<template>
  <v-switch :input-value="requirement.wipAuditor" :label="$t('requirement.wipAuditor')" @change="toggle"></v-switch>
</template>

<script>
import UpdateMinimalRequirementMutation from "@/gql/mutations/UpdateMinimalRequirementMutation.gql";
import UpdateStepModelRequirementMutation from "@/gql/mutations/UpdateStepModelRequirementMutation.gql";

export default {
  props: {
    model: {
      type: String,
      default: "minimal",
    },

    requirement: {
      type: Object,
      required: true,
    },
  },

  computed: {
    mutation() {
      return this.model === "minimal" ? UpdateMinimalRequirementMutation : UpdateStepModelRequirementMutation;
    },
  },

  methods: {
    async toggle() {
      await this.$apollo.mutate({
        mutation: this.mutation,
        variables: {
          id: this.requirement.id,
          input: {
            wipAuditor: !this.requirement.wipAuditor,
          },
        },
      });
    },
  },
};
</script>
